
import {css} from 'lit';
// eslint-disable-next-line import/prefer-default-export
export const style = css`/**
 * @tokens Hidden
 */
/* @presenter FontWeight */
/* @presenter FontWeight */
/* @presenter FontWeight */
/* @presenter FontWeight */
/* @presenter LineHeight */
/* @presenter LineHeight */
/* @presenter LineHeight */
/* @presenter LineHeight */
/* @presenter LineHeight */
/* @presenter LineHeight */
/* @presenter FontSize */
/* @presenter FontSize */
/* @presenter FontSize */
/* @presenter FontSize */
/* @presenter FontSize */
/* @presenter FontSize */
/* @presenter FontSize */
/* @presenter FontSize */
/**
 * Padding Sizes
 */
/**
 * Border Radiuses
 */
/**
 * @tokens Hidden
 */
/**
 * @tokens Padding Sizes
 * @presenter Spacing
 */
/**
 * @tokens Border Radiuses
 * @presenter BorderRadius
 */
/**
 * @tokens Hidden
 */
/**
 * Border / offset sizes
 */
.slh-notification {
  font-family: var(--slh-default-font-family, "Open Sans");
  font-size: var(--slh-base-xs-font-size, 14px);
  line-height: var(--slh-base-xxs-line-height, 24px);
  position: fixed;
  color: var(--slh-color-neutral, #39455D);
  display: none;
  filter: drop-shadow(0px 8px 24px var(--slh-color-neutral-shade-80-opacity-12, rgba(78, 94, 126, 0.16)));
  -webkit-filter: drop-shadow(0px 8px 24px var(--slh-color-neutral-shade-80-opacity-12, rgba(78, 94, 126, 0.16)));
  z-index: 100000;
}
.slh-notification .notification-container {
  display: flex;
  flex-direction: column;
  background: var(--slh-color-neutral-shade-00, #FFFFFF);
  border-radius: 80px;
}
.slh-notification .notification-container .notification--text {
  flex-direction: column;
  display: flex;
  flex: 1;
}
.slh-notification .notification-container .notification-holder {
  display: flex;
  align-items: center;
  padding: 8px;
}
.slh-notification.notification--opened {
  display: block;
}
.slh-notification .notification--title {
  font-weight: var(--slh-base-bold-font-weight, 700);
  margin-right: 4px;
}
.slh-notification .notification--content {
  font-weight: var(--slh-base-semi-bold-font-weight, 600);
  color: var(--slh-color-neutral-shade-60, #62779F);
}
.slh-notification .notification--content slot::slotted(a) {
  color: var(--slh-color-primary, #3B87D4);
  text-decoration: none;
}
.slh-notification.notification--centered {
  left: 50%;
  transform: translateX(-50%);
  width: max-content;
}
.slh-notification.notification--toast .notification-container {
  padding: 0 4px;
}
.slh-notification.notification--toast button.close-button {
  padding: 0;
  background-color: transparent;
  border: 0;
  outline: none;
  cursor: pointer;
  margin-left: auto;
}
.slh-notification.notification--toast button.close-button slh-icon {
  fill: var(--slh-color-neutral-shade-40, #C0C8D8);
  margin-left: 16px;
}
.slh-notification.notification--toast button.close-button:focus slh-icon {
  fill: var(--slh-color-neutral-shade-80, #4E5E7E);
}
.slh-notification.notification--info .icon-left slh-icon {
  background-color: var(--slh-color-info, #74B9FF);
}
.slh-notification.notification--error .icon-left slh-icon {
  background-color: var(--slh-color-error, #FF7E70);
}
.slh-notification.notification--warning .icon-left slh-icon {
  background-color: var(--slh-color-warning, #FDCB6E);
}
.slh-notification.notification--success .icon-left slh-icon {
  background-color: var(--slh-color-success, #00B894);
}
.slh-notification .icon-left {
  margin-right: 16px;
}
.slh-notification .icon-left slh-icon {
  padding: 8px;
  border-radius: 40px;
  fill: var(--slh-color-neutral-shade-00, #FFFFFF);
}
.slh-notification slh-icon {
  display: flex;
}

@media only screen and (max-width: calc(560px - 1px)) {
  .slh-notification.notification--centered {
    transform: none;
  }
}
`;
